import {defineStore} from "pinia";

export const useTranslationsStore: any = defineStore("translations", {
  state: (): any => (window.FormEngine.engineConfig.translations),
  getters: {
    getData: (state) => (path: string, showErrors: boolean = true, lang: string, fallbackLang: string) => {
      // Set lang
      if (lang in state) {
        path = lang + "." + path;
      } else {
        path = fallbackLang + "." + path;
        showError("The current language does not exist. Setting fallback language.", true);
      }

      // Get value from store
      return traverseObject(showErrors, state, path);
    },
  },
  actions: {
    setData(path: string, newValue: any, createIfMissing: boolean, lang: string) {
      // Set path to store
      path = lang + "." + path;

      // Set new value to store
      traverseObject(true, this, path, newValue, createIfMissing);
    },
  },
});

const traverseObject = (
  showErrors: boolean = true,
  store: any,
  path: string,
  setData: any = null,
  createIfMissing: boolean = false
): any => {
  // If something wrong
  if (typeof store !== "object") showError("Store is not defined", showErrors);
  if (!path) showError("Path is not defined", showErrors);
  if (!path || typeof store !== "object") return;

  const segments: string[] = path.split(".");
  const lastSegment = segments[segments.length - 1];
  let data: any = store;

  // Get data
  for (let i = 0; i < segments.length; i++) {
    const segment: string = segments[i];
    // If param exist in data
    if (segment in data) {
      // Except last item
      if (i < segments.length - 1) {
        data = data[segment];
      }
    } else if (createIfMissing) {
      data[segment] = {};
      data = data[segment];
    } else {
      showError("Path: " + path + " not exist", showErrors)
      return undefined;
    }
  }

  // Set new data value
  if (setData) {
    if (lastSegment in data) {
      data[lastSegment] = setData;
      return;
    }
  }

  return data[lastSegment];
}

const showError = (message: any, showErrors: boolean) => {
  return showErrors ? console.error(message) : null;
}
